"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPayloadControl = void 0;
var DeviceCharacteristic_1 = require("../../../../common/DeviceCharacteristic");
// import { PayloadControlType } from '../types/PayloadControlType';
var setPayloadControl = function (device, 
//Set to default as successful end of upload
request) {
    var _a;
    if (request === void 0) { request = { payloadControlCode: 3 }; }
    return device.writeCharacteristicValues((_a = device.profile) === null || _a === void 0 ? void 0 : _a.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.CONTROL; }).uuid, Uint8Array.of(request.payloadControlCode));
};
exports.setPayloadControl = setPayloadControl;
